import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";

import { syncDataDealers } from "~/pages/Dealers/Request/SyncDataDealers";
import { useNotify } from "~/shared/hooks/useNotify";

export default function useSyncdataDealers() {
  const { t } = useTranslation();

  const { notifySuccess } = useNotify();
  return useMutation({
    mutationFn: syncDataDealers, // Просто функция, которую нужно выполнить
    onSuccess: () => {
      notifySuccess(t("common.import_completed"));
    },
    onError: (error) => {
      console.log(error);
    },
  });
}
